import { useLazyGetAggregatedTableDataQuery } from '@api/utrv';
import { convertInputData } from '@utils/valueDataTable';
import { InputColumn, TableDataInfo } from '@g17eco/types/questionInterfaces';
import { UniversalTrackerPlain } from '@g17eco/types/universalTracker';
import { isTableGroupAggregation } from '@utils/universalTracker';
import { useEffect, useMemo } from 'react';

interface Props {
  utr: Pick<UniversalTrackerPlain, 'valueValidation'> | undefined;
  utrvId: string | undefined;
  table: TableDataInfo;
}

export const useGetAggregatedTableData = ({ utr, table, utrvId }: Props) => {
  const columnMap = useMemo(() => {
    const columns = utr?.valueValidation?.table?.columns ?? [];
    return new Map(columns.map((c) => [c.code, c]));
  }, [utr?.valueValidation?.table?.columns]);

  const tableData = useMemo(
    () => table.rows.reduce<InputColumn[][]>((acc, row) => (row.isRemoved ? acc : [...acc, row.data]), []),
    [table.rows],
  );

  const [getAggregatedTableData, { data: aggregatedTableData }] = useLazyGetAggregatedTableDataQuery();

  useEffect(() => {
    if (!utrvId || !tableData?.length || !utr || !isTableGroupAggregation(utr)) {
      return;
    }
    getAggregatedTableData({ utrvId, tableData: convertInputData(tableData, columnMap) });
  }, [tableData, utrvId, getAggregatedTableData, utr, columnMap]);

  if (utr && !isTableGroupAggregation(utr)) {
    return;
  }

  return aggregatedTableData;
};
